import { Spinner } from "@blueprintjs/core"
import React from "react"

const ContainerSpinner = () => {
  return (
    <div className="h-full w-full d-center">
      <Spinner />
    </div>
  )
}

export default ContainerSpinner
